// ============================================================
// Cache server-rendered JDGM badge HTML immediately on script
// load — BEFORE Smart Filter replaces the DOM (~1 second later)
// ============================================================
window.decantJdgmCache = window.decantJdgmCache || {};
(function() {
  document.querySelectorAll('.jdgm-widget.jdgm-preview-badge[data-id]').forEach(function(el) {
    var id = el.getAttribute('data-id');
    if (id && el.innerHTML.trim()) {
      window.decantJdgmCache[id] = el.innerHTML;
    }
  });
})();

// Cache low-stock handles from server-rendered Liquid DOM, BEFORE Smart Filter replaces it
window.dtLowStockCache = window.dtLowStockCache || {};
(function() {
  document.querySelectorAll('[data-dt-low-stock="true"]').forEach(function(c) {
    var a = c.querySelector('a[href*="/products/"]');
    if (!a) return;
    var m = a.pathname.match(/\/products\/([^?#\/]+)/);
    if (m) window.dtLowStockCache[m[1]] = true;
  });
})();

(function() {
  if (document.querySelector('style[data-decant]')) return;
  var s = document.createElement('style');
  s.setAttribute('data-decant', '1');
  s.textContent = '.decant-quick-add{margin-top:12px;position:relative;z-index:2}.card-wrapper .jdgm-prev-badge{min-height:26px}.decant-variants{display:flex!important;flex-wrap:wrap!important;gap:8px!important;margin-bottom:10px!important}.decant-variant-pill{padding:8px 16px!important;border:1.5px solid #d1d1d1!important;background:#fff!important;border-radius:6px!important;font-size:14px!important;line-height:1.4!important;cursor:pointer!important;color:#1a1a1a!important;font-family:inherit!important;font-weight:500!important;display:inline-block!important}.decant-variant-pill:hover:not(:disabled){border-color:#1a1a1a!important}.decant-variant-pill.active{border:2px solid #1a1a1a!important;font-weight:700!important}.decant-variant-pill.unavailable{opacity:.35!important;cursor:not-allowed!important;text-decoration:line-through!important}.decant-variant-more{padding:8px 14px!important;border:1.5px solid #d1d1d1!important;border-radius:6px!important;font-size:14px!important;color:#1a1a1a!important;text-decoration:none!important;display:inline-flex!important;align-items:center!important;font-weight:500!important}.decant-add-btn{width:100%!important;padding:12px 16px!important;border:1.5px solid #1a1a1a!important;background:#fff!important;color:#1a1a1a!important;font-size:13px!important;font-weight:700!important;letter-spacing:.08em!important;cursor:pointer!important;text-transform:uppercase!important;border-radius:6px!important;font-family:inherit!important;display:block!important;box-sizing:border-box!important}.decant-add-btn:hover:not(:disabled){background:#1a1a1a!important;color:#fff!important}.decant-add-btn.is-success{background:#1a6e1a!important;border-color:#1a6e1a!important;color:#fff!important}.decant-add-btn.is-error{border-color:#c0392b!important;color:#c0392b!important}.decant-price{display:flex!important;align-items:center!important;gap:10px!important;margin-bottom:10px!important}.decant-price-current{font-size:1.5rem!important;font-weight:700!important;color:#1a1a1a!important}.decant-price-compare{font-size:1.1rem!important;color:#999!important;text-decoration:line-through!important;font-weight:400!important}.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge{display:block!important}.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge.jdgm--waiting-for-batch-done{display:block!important}.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge[data-number-of-reviews="0"] .jdgm-prev-badge__stars{display:inline-flex!important;visibility:visible!important}.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge[data-number-of-reviews="0"] .jdgm-star{display:inline-block!important;visibility:visible!important}.decant-zero-placeholder{display:block!important}.decant-zero-placeholder .jdgm-prev-badge__stars{display:inline-flex!important;visibility:visible!important}.decant-zero-placeholder .jdgm-star{display:inline-block!important;visibility:visible!important}';
  document.head.appendChild(s);
})();

function decantUpdatePrice(wrapper, price, compare) {
  var cur = wrapper.querySelector('.decant-price-current');
  var cmp = wrapper.querySelector('.decant-price-compare');
  if (cur && price) cur.textContent = price;
  if (cmp) {
    if (compare && compare !== price) { cmp.textContent = compare; cmp.style.display = ''; }
    else { cmp.style.display = 'none'; }
  }
}

window.decantPill = function(p) {
  if (p.classList.contains('unavailable')) return;
  var savedScroll = window.scrollY;
  var wrapper = p.closest('.decant-quick-add') || p.closest('.card-wrapper, .product-card-wrapper');
  if (!wrapper) return;
  wrapper.querySelectorAll('.decant-variant-pill').forEach(function(x) { x.classList.remove('active'); });
  p.classList.add('active');
  decantUpdatePrice(wrapper, p.dataset.variantPrice, p.dataset.variantCompare);
  var alert = wrapper.querySelector('.dt-stock-alert');
  if (alert) {
    var cw = p.closest('.card-wrapper, .product-card-wrapper');
    var isProductLowStock = (cw && cw.getAttribute('data-dt-low-stock') === 'true');
    var variantStock = parseInt(p.dataset.stock, 10);
    var isVariantLowStock = !isNaN(variantStock) && variantStock > 0 && variantStock <= 3;
    alert.style.display = (isProductLowStock || isVariantLowStock) ? '' : 'none';
  }
  window.requestAnimationFrame(function() { window.scrollTo({ top: savedScroll, behavior: 'instant' }); });
};

window.decantAdd = function(btn) {
  var w = btn.closest('.decant-quick-add') || btn.closest('.card-wrapper, .product-card-wrapper');
  if (!w) return;
  var a = w.querySelector('.decant-variant-pill.active');
  if (!a) return;
  var id = parseInt(a.dataset.variantId, 10);
  var t = btn.textContent.trim();
  var savedScroll = window.scrollY;
  btn.disabled = true;
  btn.textContent = 'Agregando...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: 1 })
  })
  .then(function(r) { if (!r.ok) throw 0; return r.json(); })
  .then(function() {
    btn.classList.add('is-success');
    btn.textContent = '✓ Agregado';
    requestAnimationFrame(function() { requestAnimationFrame(function() { window.scrollTo(0, savedScroll); }); });
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      document.querySelectorAll('.cart-count-bubble span,[data-cart-count],.cart-count').forEach(function(el) {
        el.textContent = c.item_count;
      });
    });
    setTimeout(function() { btn.classList.remove('is-success'); btn.textContent = t; btn.disabled = false; }, 2500);
  })
  .catch(function() {
    btn.classList.add('is-error');
    btn.textContent = 'Error, intenta de nuevo';
    setTimeout(function() { btn.classList.remove('is-error'); btn.textContent = t; btn.disabled = false; }, 2500);
  });
};

function decantMoney(cents) {
  return '$' + (cents / 100).toLocaleString('es-CL');
}

// Returns a Promise so decantInitAll knows when all product fetches are done
function decantInjectCard(card) {
  if (card.querySelector('.decant-quick-add, .decant-variants')) return Promise.resolve();
  var link = card.querySelector('a[href*="/products/"]');
  if (!link) return Promise.resolve();
  var match = link.pathname.match(/\/products\/([^?#\/]+)/);
  if (!match) return Promise.resolve();
  var handle = match[1];

  return fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      var priceEl = card.querySelector('.price');
      if (!priceEl) return;

      var v0 = product.variants[0];
      var compareHtml = (v0.compare_at_price && v0.compare_at_price > v0.price)
        ? '<s class="decant-price-compare">' + decantMoney(v0.compare_at_price) + '</s>' : '';
      var pillsHtml = product.variants.slice(0, 4).map(function(v, i) {
        var cls = 'decant-variant-pill' + (i === 0 ? ' active' : '') + (!v.available ? ' unavailable' : '');
        var cmp = v.compare_at_price ? ' data-variant-compare="' + decantMoney(v.compare_at_price) + '"' : '';
        var stockAttr = (v.inventory_quantity != null) ? ' data-stock="' + v.inventory_quantity + '"' : '';
        return '<button class="' + cls + '" data-variant-id="' + v.id + '" data-variant-price="' + decantMoney(v.price) + '"' + cmp + stockAttr + ' type="button" onclick="event.stopPropagation();decantPill(this)"' + (!v.available ? ' disabled' : '') + '>' + v.title + '</button>';
      }).join('');
      if (product.variants.length > 4) pillsHtml += '<a href="/products/' + handle + '" class="decant-variant-more">+</a>';

      // Storefront API hides inventory_quantity; use handle-based cache populated from Liquid DOM

      var widget = '<div class="decant-quick-add">'
        + '<div class="decant-price">' + compareHtml + '<span class="decant-price-current">' + decantMoney(v0.price) + '</span></div>'
        + '<div class="decant-variants">' + pillsHtml + '</div>'
        + '<button class="decant-add-btn" type="button" onclick="event.stopPropagation();decantAdd(this)"' + (!product.available ? ' disabled' : '') + '>'
        + (product.available ? 'Agregar al carro' : 'Agotado') + '</button></div>';

      // Remove original JDGM widget from Liquid to avoid duplication
      var origJdgm = card.querySelector('.jdgm-widget.jdgm-preview-badge');
      if (origJdgm) origJdgm.remove();

      // Inject our controlled JDGM widget (with decant-jdgm marker class)
      // For products without a server-rendered cached badge, inject the native-looking
      // 0-review badge immediately so users see something; batchRenderBadges will
      // overwrite it with the real rating for products that have reviews.
      // Use a non-jdgm class so batchRenderBadges always processes this widget.
      // If the class were jdgm-prev-badge, JDGM would detect existing content and skip it,
      // leaving products with real reviews incorrectly showing "No reseñas".
      var ZERO_BADGE = '<div class="decant-zero-placeholder">'
        + '<span class="jdgm-prev-badge__stars" data-score="0.00">'
        + '<span class="jdgm-star jdgm--off"></span>'
        + '<span class="jdgm-star jdgm--off"></span>'
        + '<span class="jdgm-star jdgm--off"></span>'
        + '<span class="jdgm-star jdgm--off"></span>'
        + '<span class="jdgm-star jdgm--off"></span>'
        + '</span>'
        + '<span class="jdgm-prev-badge__text">No reseñas</span>'
        + '</div>';
      var cachedBadge = window.decantJdgmCache[String(product.id)] || ZERO_BADGE;
      priceEl.insertAdjacentHTML('beforebegin',
        '<div class="jdgm-widget jdgm-preview-badge decant-jdgm" data-id="' + product.id + '">' + cachedBadge + '</div>'
      );

      priceEl.insertAdjacentHTML('afterend', widget);
      priceEl.style.display = 'none';
      var cw = card.closest('.card-wrapper') || card;
      cw.setAttribute('data-available', String(product.available));
      if (!product.available) cw.classList.add('dt-card-sold-out');

   

    })
    .catch(function() {});
}

function decantFixReviews() {
  // Translate JDGM review text to Spanish.
  // batchRenderBadges handles all badge rendering — we only translate here.
  document.querySelectorAll('.jdgm-prev-badge__text').forEach(function(el) {
    var t = el.textContent.trim();
    el.textContent = t
      .replace(/^(\d+) reviews$/i, function(m, n) { return n + ' reseñas'; })
      .replace(/^1 review$/i, '1 reseña')
      .replace(/^no reviews$/i, 'No reseñas')
      .replace(/^write a review$/i, 'Escribir reseña')
      .replace(/^be the first to write a review$/i, 'Sin reseñas');
  });
}

function decantInitAll() {
  clearTimeout(window.decantJdgmTimer);
  // Refresh low-stock cache from current DOM (handles Liquid AJAX re-renders from Smart Filter)
  document.querySelectorAll('[data-dt-low-stock="true"]').forEach(function(c) {
    var a = c.querySelector('a[href*="/products/"]');
    if (!a) return;
    var m = a.pathname.match(/\/products\/([^?#\/]+)/);
    if (m) window.dtLowStockCache[m[1]] = true;
  });
  decantRecache(); // capture any badges still in DOM before re-render wipes them

  var cards = Array.from(document.querySelectorAll('.card-wrapper, .product-card-wrapper'));
  Promise.all(cards.map(decantInjectCard)).then(function() {
    // Translate any cached badges already in the DOM (server-rendered, may be English)
    decantFixReviews();

    // Trigger JDGM to fill empty widgets, then update cache with whatever it rendered
    function runJdgm() {
      if (window.jdgm) {
        // loadBadgesInContainer scans for .jdgm-preview-badge elements and renders them
        // — the correct API for AJAX-added badges (batchRenderBadges needs an arg array, pushWidgets doesn't exist)
        try { window.jdgm.loadBadgesInContainer && window.jdgm.loadBadgesInContainer(document); } catch(e) {}
        try { window.jdgm.initializeWidgets && window.jdgm.initializeWidgets(); } catch(e) {}
      }
    }
    runJdgm();
    window.decantJdgmTimer = setTimeout(function() {
      runJdgm(); // retry after 500ms in case first call was too early
      setTimeout(function() {
        // Re-cache whatever JDGM rendered so future re-renders use it
        document.querySelectorAll('.jdgm-widget.jdgm-preview-badge[data-id]').forEach(function(el) {
          var id = el.getAttribute('data-id');
          var html = el.innerHTML.trim();
          if (id && html) window.decantJdgmCache[id] = html;
        });
        decantFixReviews();
      }, 1500);
    }, 500);
  });
}

function decantRecache() {
  document.querySelectorAll('.jdgm-widget.jdgm-preview-badge[data-id]').forEach(function(el) {
    var id = el.getAttribute('data-id');
    var html = el.innerHTML.trim();
    if (id && html) window.decantJdgmCache[id] = html; // always overwrite with latest
  });
}

document.addEventListener('DOMContentLoaded', function() {
  decantRecache(); // phase 2: capture server-rendered badges

  decantInitAll();

  // Phase 3 & 4: capture JDGM client-side rendered badges (0-review products)
  // JDGM renders these async via XHR, typically finishes within 1-2 seconds
  setTimeout(decantRecache, 1200);
  setTimeout(decantRecache, 2500);

  // MutationObserver: catches Smart Filter & Search grid re-renders
  var timer;
  var observer = new MutationObserver(function(mutations) {
    var hasCards = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) {
        return n.nodeType === 1 && (
          (n.classList && (n.classList.contains('card-wrapper') || n.classList.contains('product-card-wrapper'))) ||
          (n.querySelector && n.querySelector('.card-wrapper, .product-card-wrapper'))
        );
      });
    });
    if (hasCards) {
      clearTimeout(timer);
      timer = setTimeout(function() {
        decantInitAll();
        if (typeof showRevieCollectionsNew === 'function') { setTimeout(showRevieCollectionsNew, 400); }
      }, 150);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Listen for Smart Filter & Search custom events (multiple possible vendor names)
  var filterEvents = [
    'filter:updated', 'filter:finish', 'filter:complete',
    'collection:updated', 'collection:rerender',
    'boost_pfs:afterRenderSection', 'boost_pfs:afterRender',
    'smartfilter:finish', 'smart_filter:finish',
    'filtr:render:done', 'globo:filter:done'
  ];
  filterEvents.forEach(function(evt) {
    document.addEventListener(evt, function() {
      clearTimeout(timer);
      timer = setTimeout(decantInitAll, 200);
    });
  });
});

// Fallback: intercept card link overlay clicks that land inside .decant-quick-add
document.addEventListener('click', function(e) {
  var a = (e.target.tagName === 'A') ? e.target : e.target.closest('a');
  if (!a) return;
  var card = a.closest('.card-wrapper, .product-card-wrapper');
  if (!card) return;
  var qa = card.querySelector('.decant-quick-add');
  if (!qa) return;
  var rect = qa.getBoundingClientRect();
  if (e.clientX < rect.left || e.clientX > rect.right ||
      e.clientY < rect.top  || e.clientY > rect.bottom) return;
  e.preventDefault();
  e.stopPropagation();
  a.style.pointerEvents = 'none';
  var el = document.elementFromPoint(e.clientX, e.clientY);
  a.style.pointerEvents = '';
  if (!el) return;
  var btn = el.closest('.decant-add-btn');
  var pill = el.closest('.decant-variant-pill');
  if (btn && !btn.disabled) window.decantAdd(btn);
  else if (pill && !pill.disabled) window.decantPill(pill);
}, false);

// ==================================================
// Cart Upsell - "Te podría interesar" en iCart
// ==================================================
(function() {
  function dtUpsellGetProducts(cart, cb) {
    if (!cart.items || cart.items.length === 0) { cb([]); return; }
    var pid = cart.items[0].product_id;
    var cartIds = cart.items.map(function(i) { return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        cb((d.products || []).filter(function(p) {
          return p.available && cartIds.indexOf(p.id) < 0;
        }).slice(0, 3));
      })
      .catch(function() { cb([]); });
  }

  function dtUpsellBuild(products) {
    if (!products.length) return '';
    var h = '<div class="dt-cart-upsell"><p class="dt-cart-upsell__title">Te podría interesar</p>';
    products.forEach(function(p) {
      var v = p.variants[0];
      var imgSrc = p.images[0] ? p.images[0].src.replace(/^http:/, 'https:') : '';
      if (imgSrc && imgSrc.indexOf('?') < 0) imgSrc += '?width=108';
      var name = p.title.length > 45 ? p.title.slice(0, 45) + '…' : p.title;
      var price = '$' + Math.round(v.price / 100).toLocaleString('es-CL');
      var lowStock = v.available && v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= 3;
      h += '<a href="/products/' + p.handle + '" class="dt-upsell-card">';
      h += '<div class="dt-upsell-img-wrap">';
      if (imgSrc) h += '<img src="' + imgSrc + '" alt="" width="54" height="54" loading="lazy">';
      if (lowStock) h += '<span class="dt-upsell-badge">Últimas unidades</span>';
      h += '</div>';
      h += '<div class="dt-upsell-card__info"><p class="dt-upsell-card__name">' + name + '</p>';
      h += '<p class="dt-upsell-card__price">' + price + '</p></div>';
      h += '<button class="dt-upsell-card__cta" data-vid="' + v.id + '" onclick="event.preventDefault();event.stopPropagation();window.dtUpsellAdd(this)" type="button">Agregar</button>';
      h += '</a>';
    });
    return h + '</div>';
  }

  function dtUpsellInject(root) {
    if (!root || root.querySelector('.dt-cart-upsell')) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        dtUpsellGetProducts(cart, function(products) {
          var html = dtUpsellBuild(products);
          if (!html) return;
          var after = root.querySelector('#corner-cowi-cart-item-list-card');
          if (after) { after.insertAdjacentHTML('afterend', html); return; }
          var before = root.querySelector('#corner-cowi-cart-summary-card');
          if (before) { before.insertAdjacentHTML('beforebegin', html); return; }
          root.insertAdjacentHTML('beforeend', html);
        });
      })
      .catch(function() {});
  }

  window.dtUpsellAdd = function(btn) {
    var id = parseInt(btn.dataset.vid, 10);
    if (!id || btn.disabled) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r) { if (!r.ok) throw 0; return r.json(); })
    .then(function() {
      btn.textContent = '✓';
      var card = btn.closest('.dt-upsell-card');
      if (card) {
        setTimeout(function() {
          card.style.transition = 'opacity 0.3s';
          card.style.opacity = '0';
          setTimeout(function() { card.remove(); }, 320);
        }, 900);
      }
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
        document.querySelectorAll('.cart-count-bubble span,[data-cart-count],.cart-count,.icart-cart-count').forEach(function(el) {
          el.textContent = c.item_count;
        });
      });
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() { btn.disabled = false; btn.textContent = orig; }, 2000);
    });
  };

  var dtUpsellTimer = null;
  var dtObs = new MutationObserver(function() {
    clearTimeout(dtUpsellTimer);
    dtUpsellTimer = setTimeout(function() {
      var itemList = document.querySelector('#corner-cowi-cart-item-list-card');
      if (!itemList) return;
      dtUpsellInject(itemList.parentElement);
    }, 100);
  });

  document.addEventListener('DOMContentLoaded', function() {
    dtObs.observe(document.body, { childList: true, subtree: true });
  });
})();
